var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshLite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.85 16.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75,5.61a.61.61,0,0,0-.86-.18.63.63,0,0,0-.19.86A5.67,5.67,0,0,1,6.93,15,5.67,5.67,0,0,1,6.38,3.71L5,6.12a.63.63,0,0,0,.54,1A.6.6,0,0,0,6,6.76L8.19,3.11A.63.63,0,0,0,8,2.25L4.32.09a.62.62,0,0,0-.86.22.61.61,0,0,0,.22.85L6,2.51a6.91,6.91,0,1,0,6.8,3.1Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLite);
export default __webpack_public_path__ + "static/media/refresh-lite.7dd1be50d38d2125b91ccb483659d63b.svg";
export { ForwardRef as ReactComponent };